import { Component, Input, OnInit } from '@angular/core';
import { ModalUpdateSeatsService } from '../../services/modal-update-seats/modal-update-seats.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-update-seats-modal',
  templateUrl: './update-seats-modal.component.html',
  styleUrls: ['./update-seats-modal.component.scss']
})
export class UpdateSeatsModalComponent implements OnInit {

  @Input() data

  seatForm: UntypedFormGroup;

  public table: any = null;

  constructor(
    private modalUpdateSeatsService: ModalUpdateSeatsService,
  ) { }

  ngOnInit(): void {
    this.seatForm = new UntypedFormGroup({ });

    this.table = this.data;

    for (let i = 0; i < this.table.seats.length; i++) {
      const seat = this.table.seats[i];

      const formControl = new UntypedFormControl(seat.seatName, [Validators.required, Validators.maxLength(128)]); 
    
      this.seatForm.addControl(seat.seatNum, formControl);
    }
  }

  getSeats() {
    let seats = this.table.seats;
    let updatedSeats = [ ];

    for (let i = 0; i < seats.length; i++) {

      let seat = seats[i];
      const seatName = this.seatForm.get(`${seat.seatNum}`).value;

      seat.seatName = seatName;

      updatedSeats.push(seat);
    }
    return updatedSeats;
  }

  update() {
    const seats = this.getSeats()
    this.modalUpdateSeatsService.close({result: seats});
  }

  modalClose() {
    this.modalUpdateSeatsService.close({result: false});
  }
}
